import React, { useState, useEffect } from "react";
import axiosInstance from "../../services/auth";
import "./Company.css";
import { useCombinedContext } from "../../context/CombinedContext";
import { toast } from "react-toastify";


const CompanyForm = ({ company, onClose }) => {
   const { setCompany,setAllCompanies ,setSelectedCompany} = useCombinedContext();
     const [loadingButton, setLoadingButton] = useState(false);
   

  const [formData, setFormData] = useState(
    company
      ? {
          ...company,
        }
      : {
          company_code: "",
          company_name: "",
          bank_account_no: "",
          vessal_code_starting_no: "",
          co_regno: "",
          gst_no: "",
          gst_pct: "",
          address: "",
          telephone: "",
          fax: "",
          email: "",
          status: "true",
        }
  );

  const handleOutsideClick = (e) => {
    if (e.target.classList.contains("modal")) {
      onClose();
    }
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name.includes(".")) {
      const [parent, child] = name.split(".");
      setFormData((prevState) => ({
        ...prevState,
        [parent]: {
          ...prevState[parent],
          [child]: value,
        },
      }));
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingButton(true);
  
    const request = company
      ? axiosInstance.patch(`/company/${company._id}`, formData)
      : axiosInstance.post("/company", formData);
  
    request
      .then((response) => {
        // console.log("Response", response);
        // If the server indicates an error (statusCode 400), throw an error.
        if (response.data.statusCode === 400) {
          // Throw an error so that the chain jumps to the catch block.
          throw { response: { data: { message: response.data.message[0] } } };
        }
        return axiosInstance.get("/company/userCompany");
      })
      .then((response) => {
        setCompany(response.data.companies);
        toast.success(company ? "Company updated successfully" : "Company added successfully");
        if (company) setSelectedCompany();
        onClose(); // Close modal only after success
      })
      .catch((error) => {
        // This will now show only one error toast.
        toast.error(error.response?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setLoadingButton(false);
      });
  };
  
  


  return (
    <div
      className="modal show d-block"
      tabIndex="-1"
      onClick={handleOutsideClick}
      style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
    >
      <div
        className="modal-dialog modal-lg modal-dialog-centered"
        role="document"
      >
        <div className="modal-content ">
          <div className="modal-header text-white text-center vesel_form">
            <h5 className="modal-title">
              {company ? "Edit Company" : "Create Company"}
            </h5>
            <button
              type="button"
              className="btn-close text-white"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body vesel_form">
            <form onSubmit={handleSubmit}>
              {/* Company Details Section */}
              <div className="card shadow-sm mb-4 rounded-3 ">
                <div className="card-body ">
                  <h5 className="card-title text-center mb-4">
                    Company Details
                  </h5>
                  <div className="row ">
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Company Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="company_name"
                        value={formData?.company_name}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="col-md-4 mb-3">
                      <label className="form-label">Company Code</label>
                      <input
                        type="text"
                        className="form-control"
                        name="company_code"
                        value={formData?.company_code}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Bank Account No</label>
                      <input
                        type="text"
                        className="form-control"
                        name="bank_account_no"
                        value={formData?.bank_account_no}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Co Reg No</label>
                      <input
                        type="text"
                        className="form-control"
                        name="co_regno"
                        value={formData.co_regno}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Vessel Code Starting No</label>
                      <input
                        type="number"
                        className="form-control"
                        name="vessal_code_starting_no"
                        value={formData.vessal_code_starting_no}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label">GST No</label>
                      <input
                        type="text"
                        className="form-control"
                        name="gst_no"
                        value={formData.gst_no}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label">GST %</label>
                      <input
                        type="number"
                        className="form-control"
                        name="gst_pct"
                        value={formData.gst_pct}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Address</label>
                      <input
                        type="text"
                        className="form-control"
                        name="address"
                        value={formData.address}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Telephone</label>
                      <input
                        type="number"
                        className="form-control"
                        name="telephone"
                        value={formData.telephone}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Fax</label>
                      <input
                        type="text"
                        className="form-control"
                        name="fax"
                        value={formData.fax}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Email</label>
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Status</label><br />
                      <button
                        type="button"
                        className={`btn ststus_btn ${
                          formData.status ? "btn-success" : "btn-danger"
                        }`}
                        onClick={() =>
                          setFormData((prevData) => ({
                            ...prevData,
                            status: !prevData.status,
                          }))
                        }
                      >
                        {formData.status ? "Active" : "Inactive"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Submit Button */}
              <div className="text-center">
                <button type="submit" className="button-2 " disabled={loadingButton}>
                  {loadingButton ? company ? "Updating" : "Adding " : company ? "Update" : "Add Company" }
                
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyForm;
